export const ru = {
    'audio-title': 'Библиотека аудиороликов'
};
